export default __webpack_public_path__ + "static/media/Vägledning.402e41f2.png";